<table mat-table [dataSource]="storybookDataSource" class="mat-elevation-z4 w-full font-title">
    <!-- Name Column -->
    <ng-container matColumnDef="storyName">
        <th mat-header-cell *matHeaderCellDef> {{ 'listStories.text1' | translate}} </th>
        <td mat-cell *matCellDef="let element" class="arabic-story-name"> {{element.storyName}} </td>
    </ng-container>

    <!-- Weight Column -->
    <ng-container matColumnDef="hasAudio">
        <th mat-header-cell *matHeaderCellDef> {{ 'listStories.text2' | translate}} </th>
        <td mat-cell *matCellDef="let element"> {{element.hasAudio? 'Yes' : 'No'}} </td>
    </ng-container>

    <ng-container matColumnDef="coverImagePath">
        <th mat-header-cell *matHeaderCellDef> {{ 'listStories.text3' | translate}} </th>
        <td mat-cell *matCellDef="let element"> {{element.coverImagePath? 'Yes' : 'No'}} </td>
    </ng-container>

    <!-- Action column -->
    <ng-container matColumnDef="action">
        <th mat-header-cell *matHeaderCellDef> </th>
        <td mat-cell *matCellDef="let element">
            <button mat-icon-button (click)="callDeleteStory(element.storyName)" style="margin-left: auto; display: block; color: white;">
                <mat-icon>delete_outline</mat-icon>
            </button>
        </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
</table>
